/**
 * HeaderNode
 *
 * The topmost node in the flowchart. It acts as the entry point of the workflow
 * and visually represents the start of the identity verification process.
 *
 * Position in flowchart:
 *   [HeaderNode]  ← sits at the very top, centered above the Identity Proof group
 *        ↓
 *   [GroupNode (Identity Proof)]
 *
 * Handles:
 *   - source-bottom: connects downward to the GroupNode (Identity Proof section)
 *
 * Data props:
 *   - label: workflow name displayed below the icon (e.g. "Custom Field Workflow")
 */
import React from 'react';

import { Box, Typography } from '@mui/material';
import { Handle, Position } from '@xyflow/react';
import PropTypes from 'prop-types';

import styles from '../../FlowChartCanvas.module.css';

import { ReactComponent as WorkflowIcon } from 'asset/IconsPack/at_dataflow-04.svg';

function HeaderNode({ data }) {
    return (
        <Box className={styles.headerNode}>
            <Box className={styles.headerIconWrapper}>
                <WorkflowIcon className={styles.headerIcon} />
            </Box>
            <Typography component="span" className={styles.headerLabel}>
                {data.label}
            </Typography>

            {/* Connects downward to the Identity Proof group node */}
            <Handle
                type="source"
                position={Position.Bottom}
                id="source-bottom"
                style={{ opacity: 0 }}
            />
        </Box>
    );
}

HeaderNode.propTypes = {
    data: PropTypes.shape({
        label: PropTypes.string.isRequired,
    }).isRequired,
};

export default HeaderNode;
